module.exports = __webpack_public_path__ + "media/images/background-10-3262b4b5096d8d8d0d45bdaeb85f9f47.svg";